export const GET_IMPORTS = gql`
  query GetImports($workspaceId: String!) {
    workspaceImports(workspaceId: $workspaceId) {
      id
      filename
      createdAt
      updatedAt
      status
      hasErrors
    }
  }
`

export const GET_IMPORT = gql`
  query GetImport($workspaceId: String!, $id: String!) {
    workspaceImport(workspaceId: $workspaceId, id: $id) {
      id
      filename
      status
      hasErrors
      createdAt
      updatedAt
      storageUrl
      objectType
      userId
      metadata
      results {
        id
        columnIndex
        rowIndex
        savedTo
        savedAs
        errorMessage
        success
        sourceText
      }
    }
  }
`

export const GET_PAGE_INSTRUCTIONS = gql`
  query GetPageInstructions(
    $workspaceId: String!
    $parentObject: CRMObjectInput
    $timezone: String
  ) {
    getPageInstructions(
      workspaceId: $workspaceId
      parentObject: $parentObject
      timezone: $timezone
    )
  }
`
